import { PropsWithChildren } from "react";
import Styles from "./ErrorContainer.module.scss";

const ErrorContainer = ({ children }: PropsWithChildren) => (
  <div className={Styles.container}>{children}</div>
);
export default ErrorContainer;
